export const getCarIdFromUrl = () => {
	const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
	const carId: string | null = urlParams.get('carId');

	return carId;
};
